import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['showHideMe', 'trigger']

  connect() {
    this.toggleClass = this.data.get('class') || 'hidden';
    this.toggleIndicatorClass = this.data.get('class') || 'shown';
  }

  toggle() {
    var showHideElements = this.showHideMeTargets
    var triggerElements = this.triggerTargets
    var containerElement = this.element

    for (let showHideElement of showHideElements) {
      showHideElement.classList.toggle(this.toggleClass);
    }

    for (let triggerElement of triggerElements) {
      triggerElement.classList.toggle(this.toggleClass);
    }

    containerElement.classList.toggle(this.toggleIndicatorClass);
  }

  show() {
    var showHideElements = this.showHideMeTargets
    var triggerElements = this.triggerTargets
    var containerElement = this.element

    for (let showHideElement of showHideElements) {
      showHideElement.classList.remove(this.toggleClass);
    }

    containerElement.classList.add(this.toggleIndicatorClass);
  }

  hide() {
    var showHideElements = this.showHideMeTargets
    var triggerElements = this.triggerTargets
    var containerElement = this.element

    for (let showHideElement of showHideElements) {
      showHideElement.classList.add(this.toggleClass);
    }

    containerElement.classList.remove(this.toggleIndicatorClass);
  }

  toggle_fields(){
    var container = document.querySelector(".project-form");
    var block_types = container.querySelector(".create-configurations .configuration-types");
    var create_block_form_container = container.querySelector(".create-configurations .create-configuration-form");
    var showHideElements = this.showHideMeTargets
    var triggerElements = this.triggerTargets
    var containerElement = this.element

    for (let showHideElement of showHideElements) {
      showHideElement.classList.toggle(this.toggleClass);
    }

    for (let triggerElement of triggerElements) {
      triggerElement.classList.toggle(this.toggleClass);
    }

    containerElement.classList.toggle(this.toggleIndicatorClass);

    block_types.classList.remove("hidden");
    create_block_form_container.innerHTML = ""
  }

}